export enum FeedbackTime {
  SHORT = 300,
  MIDDLE = 600,
  LONG = 900,
}
